import React from 'react';
import PropTypes from 'prop-types';
import css from './SizeDropdown.module.css';

function SizeDropdown({ stock, onChange, selectedValue, purchaseQuantityCap, purchasedQuantity }) {
  const options = [...Array(Math.min(stock + 1, 101)).keys()];
  const MAX_AMOUNT_LIMIT = 500;

  return (
    <select className={css.root} onChange={onChange} value={selectedValue}>
      <option disabled key={`option-${0}`} value={0}>
        0
      </option>
      {options
        .slice(
          0,
          Math.min(
            selectedValue + 1 + 100,
            purchaseQuantityCap - purchasedQuantity + 1,
            MAX_AMOUNT_LIMIT
          )
        )
        .map(amount =>
          amount != 0 ? (
            <option key={`option-${amount}`} value={amount}>
              {amount}
            </option>
          ) : null
        )}
    </select>
  );
}

SizeDropdown.propTypes = {
  stock: PropTypes.number,
  onChange: PropTypes.func,
  selectedValue: PropTypes.number,
};

export default SizeDropdown;
